import React from "react";
import AddRemoveUserAdmin from "./AddRemoveUserAdmin";

const AdminDetails = () => {
  return <AddRemoveUserAdmin role="admin" />;
};

export default AdminDetails;
